import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  href?: string;
  scrollTo?: string;
  size?: 'lg' | 'xl';
  className?: string;
}
const PURCHASE_URL = 'https://ahorro-total-2.myshopify.com/cart/44075741741116:1';
export function CTAButton({
  text,
  href,
  scrollTo,
  size = 'xl',
  className = ''
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (scrollTo) {
      e.preventDefault();
      const element = document.getElementById(scrollTo);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  const sizeClasses = size === 'xl' ? 'px-10 py-5 text-xl md:text-2xl' : 'px-8 py-4 text-lg md:text-xl';
  const finalHref = scrollTo ? `#${scrollTo}` : href || PURCHASE_URL;
  return <a href={finalHref} onClick={scrollTo ? handleClick : undefined} target={!scrollTo ? '_blank' : undefined} rel={!scrollTo ? 'noopener noreferrer' : undefined} className={`
        cta-pulse inline-flex items-center justify-center gap-3
        bg-[#10b981] text-white font-heading font-bold uppercase tracking-wider
        rounded-[10px] cursor-pointer no-underline
        transition-all duration-300 ease-out
        hover:bg-[#059669]
        ${sizeClasses}
        ${className}
      `} role="button" aria-label={text} data-id="element-14">
      {text}
      <ArrowRightIcon className="w-6 h-6 flex-shrink-0" aria-hidden="true" data-id="element-15" />
    </a>;
}